import { createFeature, createReducer, on } from '@ngrx/store';

import { Activity } from 'app/shared/features/activity-selector/models';
import { sortActivities } from 'app/shared/features/activity-selector/utils';

import { updateActivities } from './activity.actions';

export const activityFeatureKey = 'activity';

export interface ActivityState {
    activityList: Activity[] | undefined;
}

export const initialState: ActivityState = { activityList: undefined };

export const reducer = createReducer(
    initialState,
    on(updateActivities, (state, { activityList }) => {
        // Actions of type 'loadActivitiesSuccess' are dispatched by master-data.service on a regular basis.
        // Here we check if the content for activity list has changed. If not then the state does not change.
        // Otherwise, components consuming activity list from the state will detect changes, and they will refresh
        // while it is not necessary. It will lead to unpredicted side effect. For example, the components
        // representing the activity list will be destroyed and recreated again on every change of the state.
        const currentJson = JSON.stringify(sortActivities(state.activityList ?? []));
        const newJson = JSON.stringify(sortActivities(activityList));
        const listChanged = currentJson !== newJson;
        return listChanged || state.activityList === undefined
            ? {
                  ...state,
                  activityList: [...activityList],
              }
            : state;
    }),
);

export const activityFeature = createFeature({
    name: activityFeatureKey,
    reducer,
});
